import { configureSlices } from "utils/store/configureSlices";

import publicShipmentManagementSlice from "./publicShipmentManagementSlice";

export const { useSlices: usePublicLoadStatusSlices, useSliceSelector: usePublicLoadStatusSliceSelector } =
  configureSlices({
    publicShipmentManagementSlice,
  });
